
__webpack_require__.S = {};
__webpack_require__.initializeSharingData = { scopeToSharingDataMapping: { "default": [54670, 45339, 47990, 65048, 2657, 91345, 17259] }, uniqueName: "canvas-lms" };
__webpack_require__.I = __webpack_require__.I || function() { throw new Error("should have __webpack_require__.I") }
